import { ReactNode } from 'react'

import { BlankSlate, Box, Spinner } from '@factorialco/deprecated-design-system'

import ErrorBoundary from 'modules/core/components/ErrorBoundary'

/*
  This component is used to manage state in pages that use an `<Outlet />` inside
  of the `Body` component. They still need some kind of normalized loading management,
  but they don't render the header or other pieces.
*/
export const NestedBody: React.FC<{
  children: ReactNode
  loading?: boolean
  error?: unknown
}> = ({ children, loading, error }) => (
  <ErrorBoundary blankSlate>
    {error ? (
      <BlankSlate illustration="alert" title="" description="" />
    ) : loading ? (
      <Box alignItems="center" justifyContent="center" height="full">
        <Spinner />
      </Box>
    ) : (
      <>{children}</>
    )}
  </ErrorBoundary>
)
